import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ordersApi } from '../../network/apis/orders';
import { shippingApi } from '../../network/apis/logistics';
import '../../assets/css/pages/order-detail.css';

// Material Design Icons
const ArrowLeftIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
    </svg>
);

const PackageIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM7.5 13h9v1.5h-9V13zm0 3.5h6V18h-6v-1.5zM12 6l4 4-4 4-1.41-1.41L12.17 11H7.5V9h4.67l-1.58-1.59L12 6z"/>
    </svg>
);

const TruckIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
    </svg>
);

const CheckCircleIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
);

const ClockIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
    </svg>
);

const MapPinIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
    </svg>
);

const PhoneIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
    </svg>
);

const CreditCardIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
    </svg>
);

const RefreshIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
    </svg>
);

const PaymentIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
    </svg>
);

const CancelIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
    </svg>
);

const HelpIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
    </svg>
);

const StarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
    </svg>
);

const OrderDetail = () => {
    const { orderId } = useParams();
    const [order, setOrder] = useState(null);
    const [shipmentTracking, setShipmentTracking] = useState([]);
    const [loading, setLoading] = useState(true);
    const [trackingLoading, setTrackingLoading] = useState(false);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [paymentError, setPaymentError] = useState(null);

    const fetchShipmentTracking = async (shipmentId) => {
        try {
            setTrackingLoading(true);
            const response = await shippingApi.getShipmentTracking(shipmentId);
            setShipmentTracking(response || []);
        } catch (error) {
            console.error('Error fetching tracking:', error);
        } finally {
            setTrackingLoading(false);
        }
    };

    const fetchOrderDetails = useCallback(async () => {
        try {
            setLoading(true);
            const response = await ordersApi.getOrderById(orderId);
            setOrder(response);
            
            // Fetch shipment tracking if order has shipment
            if (response.shipment?.id) {
                fetchShipmentTracking(response.shipment.id);
            }
        } catch (error) {
            console.error('Error fetching order:', error);
        } finally {
            setLoading(false);
        }
    }, [orderId]);

    useEffect(() => {
        fetchOrderDetails();
    }, [fetchOrderDetails]);

    // Handle Paystack payment completion
    const handleCompletePayment = async () => {
        setPaymentLoading(true);
        setPaymentError(null);
        
        try {
            // Initialize payment
            const response = await ordersApi.initiatePayment(orderId, 'paystack', window.location.href);
            // Handle nested response structure: response.data.data or response.data
            const apiResponse = response.data || response;
            const paymentData = apiResponse.data || apiResponse;
            
            console.log('Payment data:', paymentData); // Debug log
            
            // Check if Paystack is available
            if (window.PaystackPop) {
                console.log('Initializing Paystack payment...'); // Debug log
                const handler = window.PaystackPop.setup({
                    key: paymentData.public_key,
                    email: paymentData.email,
                    amount: paymentData.amount,
                    currency: paymentData.currency || 'NGN',
                    ref: paymentData.reference,
                    metadata: {
                        order_id: order.id,
                    },
                    onClose: function() {
                        setPaymentLoading(false);
                    },
                    callback: function(paystackResponse) {
                        // Verify payment (use .then/.catch since Paystack doesn't support async)
                        ordersApi.verifyPayment(orderId, paystackResponse.reference)
                            .then(() => {
                                // Refresh order details
                                fetchOrderDetails();
                                setPaymentLoading(false);
                            })
                            .catch(() => {
                                setPaymentError('Payment verification failed. Please contact support.');
                                setPaymentLoading(false);
                            });
                    }
                });
                handler.openIframe();
            } else if (paymentData.authorization_url) {
                // Redirect to Paystack if inline not available
                window.location.href = paymentData.authorization_url;
            } else {
                setPaymentError('Payment gateway not available. Please try again later.');
                setPaymentLoading(false);
            }
        } catch (error) {
            console.error('Payment initialization failed:', error);
            setPaymentError(error.response?.data?.message || 'Failed to initialize payment. Please try again.');
            setPaymentLoading(false);
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-NG', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        return new Date(dateString).toLocaleString('en-NG', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStatusStep = (status) => {
        const steps = ['PENDING', 'PROCESSING', 'SHIPPED', 'DELIVERED'];
        return steps.indexOf(status?.toUpperCase());
    };

    const handleCancelOrder = async () => {
        if (!window.confirm('Are you sure you want to cancel this order? This action cannot be undone.')) return;
        
        try {
            await ordersApi.cancelOrder(orderId);
            // Reload the page to refresh order data
            window.location.reload();
        } catch (error) {
            alert('Failed to cancel order. Please try again.');
        }
    };

    if (loading) {
        return (
            <div className="order-detail-page">
                <div className="order-detail-container">
                    <div className="loading-state">
                        <div className="loading-spinner"></div>
                        <p>Loading order details...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!order) {
        return (
            <div className="order-detail-page">
                <div className="order-detail-container">
                    <div className="error-state">
                        <h2>Order Not Found</h2>
                        <p>We couldn&apos;t find the order you&apos;re looking for.</p>
                        <Link to="/store/orders" className="btn-back-orders">
                            Back to Orders
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    const currentStep = getStatusStep(order.status);
    const isCancelled = order.status?.toUpperCase() === 'CANCELLED';

    return (
        <div className="order-detail-page">
            <div className="order-detail-container">
                {/* Header */}
                <div className="order-detail-header">
                    <Link to="/store/orders" className="btn-back">
                        <ArrowLeftIcon /> Back to Orders
                    </Link>
                    <div className="order-info">
                        <h1>Order #{order.order_number || order.id}</h1>
                        <p className="order-date">Placed on {formatDate(order.created_at)}</p>
                    </div>
                    <span className={`order-status ${order.status?.toLowerCase()}`}>
                        {order.status?.charAt(0) + order.status?.slice(1).toLowerCase()}
                    </span>
                </div>

                {/* Order Progress */}
                {!isCancelled && (
                    <div className="order-progress-section">
                        <h2>Order Status</h2>
                        <div className="progress-tracker">
                            <div className={`progress-step ${currentStep >= 0 ? 'completed' : ''}`}>
                                <div className="step-icon">
                                    <ClockIcon />
                                </div>
                                <div className="step-info">
                                    <span className="step-name">Order Placed</span>
                                    <span className="step-date">{formatDateTime(order.created_at)}</span>
                                </div>
                            </div>
                            
                            <div className="progress-line">
                                <div className={`line-fill ${currentStep >= 1 ? 'filled' : ''}`}></div>
                            </div>
                            
                            <div className={`progress-step ${currentStep >= 1 ? 'completed' : ''}`}>
                                <div className="step-icon">
                                    <PackageIcon />
                                </div>
                                <div className="step-info">
                                    <span className="step-name">Processing</span>
                                    <span className="step-date">
                                        {currentStep >= 1 ? 'Items being prepared' : 'Pending'}
                                    </span>
                                </div>
                            </div>
                            
                            <div className="progress-line">
                                <div className={`line-fill ${currentStep >= 2 ? 'filled' : ''}`}></div>
                            </div>
                            
                            <div className={`progress-step ${currentStep >= 2 ? 'completed' : ''}`}>
                                <div className="step-icon">
                                    <TruckIcon />
                                </div>
                                <div className="step-info">
                                    <span className="step-name">Shipped</span>
                                    <span className="step-date">
                                        {order.shipment?.shipped_at 
                                            ? formatDateTime(order.shipment.shipped_at)
                                            : 'On the way'
                                        }
                                    </span>
                                </div>
                            </div>
                            
                            <div className="progress-line">
                                <div className={`line-fill ${currentStep >= 3 ? 'filled' : ''}`}></div>
                            </div>
                            
                            <div className={`progress-step ${currentStep >= 3 ? 'completed' : ''}`}>
                                <div className="step-icon">
                                    <CheckCircleIcon />
                                </div>
                                <div className="step-info">
                                    <span className="step-name">Delivered</span>
                                    <span className="step-date">
                                        {order.delivered_at 
                                            ? formatDateTime(order.delivered_at)
                                            : order.estimated_delivery 
                                                ? `Est. ${formatDate(order.estimated_delivery)}`
                                                : 'Awaiting delivery'
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Cancelled Notice */}
                {isCancelled && (
                    <div className="cancelled-notice">
                        <h2>Order Cancelled</h2>
                        <p>This order was cancelled on {formatDateTime(order.cancelled_at || order.updated_at)}</p>
                        {order.cancellation_reason && (
                            <p className="cancel-reason">Reason: {order.cancellation_reason}</p>
                        )}
                    </div>
                )}

                <div className="order-detail-layout">
                    <div className="order-detail-main">
                        {/* Shipment Tracking */}
                        {order.shipment && (
                            <div className="detail-section tracking-section">
                                <div className="section-header">
                                    <h2><TruckIcon /> Shipment Tracking</h2>
                                    <button 
                                        className="btn-refresh"
                                        onClick={() => fetchShipmentTracking(order.shipment.id)}
                                        disabled={trackingLoading}
                                    >
                                        <RefreshIcon /> Refresh
                                    </button>
                                </div>
                                
                                <div className="tracking-info">
                                    <div className="tracking-row">
                                        <span className="label">Carrier:</span>
                                        <span className="value">{order.shipment.carrier_name || order.shipment.logistics_company?.company_name || 'Standard Shipping'}</span>
                                    </div>
                                    {order.shipment.tracking_number && (
                                        <div className="tracking-row">
                                            <span className="label">Tracking Number:</span>
                                            <span className="value tracking-number">{order.shipment.tracking_number}</span>
                                        </div>
                                    )}
                                    {order.shipment.estimated_delivery && (
                                        <div className="tracking-row">
                                            <span className="label">Estimated Delivery:</span>
                                            <span className="value">{formatDate(order.shipment.estimated_delivery)}</span>
                                        </div>
                                    )}
                                </div>

                                {trackingLoading ? (
                                    <div className="tracking-loading">
                                        <div className="loading-spinner small"></div>
                                        <span>Updating tracking information...</span>
                                    </div>
                                ) : shipmentTracking.length > 0 ? (
                                    <div className="tracking-timeline">
                                        {shipmentTracking.map((event, index) => (
                                            <div key={index} className={`timeline-event ${index === 0 ? 'latest' : ''}`}>
                                                <div className="event-marker"></div>
                                                <div className="event-content">
                                                    <p className="event-description">{event.description || event.status}</p>
                                                    <div className="event-meta">
                                                        <span className="event-location">
                                                            <MapPinIcon /> {event.location || 'In transit'}
                                                        </span>
                                                        <span className="event-time">
                                                            <ClockIcon /> {formatDateTime(event.timestamp || event.created_at)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p className="no-tracking">No tracking updates available yet.</p>
                                )}
                            </div>
                        )}

                        {/* Order Items */}
                        <div className="detail-section">
                            <h2><PackageIcon /> Order Items</h2>
                            <div className="items-list">
                                {(order.items || []).map((item, index) => (
                                    <div key={index} className="detail-item">
                                        <img 
                                            src={item.product_image || item.product?.image || '/placeholder.png'} 
                                            alt={item.product_name || item.product?.name || item.name}
                                        />
                                        <div className="item-info">
                                            <h3>{item.product_name || item.product?.name || item.name}</h3>
                                            <p className="item-vendor">Sold by: {item.vendor_name || item.vendor?.store_name || 'Vendor'}</p>
                                            <div className="item-pricing">
                                                <span className="qty">Qty: {item.quantity}</span>
                                                <span className="price">₦{parseFloat(item.price || item.unit_price || 0).toLocaleString()}</span>
                                            </div>
                                        </div>
                                        <div className="item-total">
                                            ₦{parseFloat(item.total || (item.price || item.unit_price || 0) * item.quantity).toLocaleString()}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="order-detail-sidebar">
                        {/* Delivery Address */}
                        <div className="sidebar-section">
                            <h3><MapPinIcon /> Delivery Address</h3>
                            <div className="address-card">
                                <p className="name">{order.recipient_name || order.customer_name}</p>
                                <p>{order.shipping_address}</p>
                                <p>{order.shipping_city}, {order.shipping_state} {order.shipping_postal_code}</p>
                                {order.shipping_phone && (
                                    <p className="phone"><PhoneIcon /> {order.shipping_phone}</p>
                                )}
                            </div>
                        </div>

                        {/* Payment Info */}
                        <div className="sidebar-section">
                            <h3><CreditCardIcon /> Payment Information</h3>
                            <div className="payment-info">
                                <div className="info-row">
                                    <span>Payment Method:</span>
                                    <span>{order.payment_method === 'paystack' ? 'Paystack' : order.payment_method === 'flutterwave' ? 'Flutterwave' : order.payment_method === 'bank_transfer' ? 'Bank Transfer' : order.payment_method === 'cash_on_delivery' ? 'Pay on Delivery' : order.payment_method || 'Not specified'}</span>
                                </div>
                                <div className="info-row">
                                    <span>Payment Status:</span>
                                    <span className={`payment-status ${order.payment_status?.toLowerCase()}`}>
                                        {order.payment_status}
                                    </span>
                                </div>
                                {order.payment_reference && (
                                    <div className="info-row">
                                        <span>Reference:</span>
                                        <span className="reference">{order.payment_reference}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Order Summary */}
                        <div className="sidebar-section order-summary">
                            <h3>Order Summary</h3>
                            <div className="summary-row">
                                <span>Subtotal</span>
                                <span>₦{parseFloat(order.subtotal || 0).toLocaleString()}</span>
                            </div>
                            <div className="summary-row">
                                <span>Shipping</span>
                                <span>₦{parseFloat(order.shipping_cost || order.delivery_fee || 0).toLocaleString()}</span>
                            </div>
                            {order.discount > 0 && (
                                <div className="summary-row discount">
                                    <span>Discount</span>
                                    <span>-₦{parseFloat(order.discount).toLocaleString()}</span>
                                </div>
                            )}
                            <div className="summary-row total">
                                <span>Total</span>
                                <span>₦{parseFloat(order.total || order.total_amount || 0).toLocaleString()}</span>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="order-actions">
                            {/* Complete Payment button for pending payments */}
                            {order.payment_status?.toUpperCase() === 'PENDING' && order.status !== 'CANCELLED' && (
                                <div className="payment-action-container">
                                    <button 
                                        className="btn-complete-payment"
                                        onClick={handleCompletePayment}
                                        disabled={paymentLoading}
                                    >
                                        {paymentLoading ? (
                                            <>
                                                <div className="btn-spinner"></div>
                                                Processing...
                                            </>
                                        ) : (
                                            <>
                                                <PaymentIcon />
                                                Complete Payment
                                            </>
                                        )}
                                    </button>
                                    {paymentError && (
                                        <p className="payment-error">{paymentError}</p>
                                    )}
                                </div>
                            )}
                            
                            {(order.status === 'PENDING' || order.status === 'PROCESSING') && (
                                <button className="btn-cancel" onClick={handleCancelOrder}>
                                    <CancelIcon />
                                    Cancel Order
                                </button>
                            )}
                            {order.status === 'DELIVERED' && (
                                <Link to={`/store/orders/${orderId}/review`} className="btn-review">
                                    <StarIcon />
                                    Write a Review
                                </Link>
                            )}
                            <button className="btn-support">
                                <HelpIcon />
                                Need Help?
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderDetail;
